import { ChangeEvent, useState, useEffect } from 'react';
import { API_URL } from '@/config';
import { Loader } from '@/components/Loader/Loader';
import { showNotification } from '@/utils/notificationUtils';
import Utils from '@/utils/util';
import { useAuth } from '@/lib/auth';
import { ReactComponent as Logo } from '@/assets/img/logo-v2.svg';
import { ReactComponent as PasswordShowIcon } from '@/assets/img/v2/password-show-icon.svg';
import { ReactComponent as PasswordHideIcon } from '@/assets/img/v2/password-hide-icon.svg';
import { ReactComponent as GoogleIcon } from '@/assets/img/v2/google-icon.svg';
import './ConsumerLogin.scss';
let myWindow: any;

import { useTranslation } from 'react-i18next';

type LoginFormProps = {
  onBack: (page: 'serviceSelection') => void;
  onNext: (page: 'forgot-password' | 'sign-up' | 'email-verification' | 'parent-profile' | undefined) => void;
};
export const ConsumerLogin = ({ onNext }: LoginFormProps) => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  useEffect(() => {
    Utils.scrollToTop();
    window.onmessage = (ev: any) => {
      if (ev.data && ev.data.profile) {
        if (myWindow) {
          myWindow.close();
        }
        login({ userData: ev.data.profile });
        if (onNext) {
          localStorage.setItem('UsersEmail', ev.data.profile?.email);
          onNext(undefined);
        }
      } else if (ev.data && ev.data.error && ev.data.error.message) {
        if (myWindow) {
          myWindow.close();
        }
        showNotification({
          type: 'error',
          title: ev.data.error.message,
        });
      }
    };
  }, []);

  const handleFormChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'email') {
      setEmail(event.target.value);
    } else if (event.target.id === 'password') {
      setPassword(event.target.value);
    }
  };

  const validate = () => {
    if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      showNotification({
        type: 'info',
        title: t('Please enter valid email'),
      });
      return false;
    } else if (!password) {
      showNotification({
        type: 'info',
        title: t('Please enter password'),
      });
      return false;
    }
    return true;
  };
  const onConsumerLoginClick = async () => {
    if (validate() && email) {
      try {
        setIsLoading(true);
        await login({
          email: email.toLowerCase(),
          password,
        });
        setIsLoading(false);
        if (onNext) {
          localStorage.setItem('UsersEmail', email.toLowerCase());
          onNext(undefined);
        }
      } catch (error: any) {
        setIsLoading(false);
        if (
          (error && error.response && error.response.data && error.response.data.message) ||
          (error && error.message)
        ) {
          let message = error.response?.data?.message || error.message;
          let errorcode;
          if (error?.response?.data?.errors && error?.response?.data?.errors?.length > 0) {
            message = `${error.response?.data?.errors[0]?.message}`;
            errorcode = error.response?.data?.errors[0]?.code;
            if (message.includes('field is required') > 0) {
              message = `${error.response?.data?.errors[0]?.field} ${error.response?.data?.errors[0]?.message}`;
            }
          }
          if (errorcode && errorcode === 'ERR067') {
            localStorage.setItem('UsersEmail', email.toLowerCase());
            onNext('email-verification');
          }
        }
      }
    }
  };
  return (
    <section className="consumer-login">
      {/* <BackNav onClick={() => onBack('serviceSelection')} /> */}
      <div className="registration-container">
        <div className="logo-section">
          <Logo />
          <p className="petsked-desc">{t('Welcome to Petsked, Sign in to your account')}</p>
        </div>
        <div className="petsked-form">
          <input
            id="email"
            type="email"
            value={email}
            onChange={handleFormChange}
            placeholder={t("Email Address")}
          />
          <span className="form-field-wrapper">
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={handleFormChange}
              placeholder={t("Password")}
            />
            {showPassword ? (
              <PasswordHideIcon onClick={() => setShowPassword(!showPassword)} />
            ) : (
              <PasswordShowIcon onClick={() => setShowPassword(!showPassword)} />
            )}
          </span>
          <p className="fp-link" onClick={() => onNext('forgot-password')}>
            {t('Forgot Password')}
          </p>
          <div className="action">
            <button
              className="petsked-button button-dark"
              onClick={onConsumerLoginClick}
              disabled={isLoading}
            >
              {isLoading ? <Loader text='signing in ...' /> : <span>{t('Sign In')}</span>}
            </button>
            <span className="seperator">
              <hr />
              <span>{t('OR')}</span>
            </span>
            <button className="petsked-button button-blue google" onClick={() => {
                  const width = 530;
                  const height = 762;
                  const left = window.screen.width / 2 - width / 2;
                  const top = window.screen.height / 2 - height / 2;
                  const windowFeatures = `toolbar=0, status=0, width=${width}, height=${height}, top=${top}, left=${left}`;
                  myWindow = window.open(
                    `${API_URL}/parent/auth/google`,
                    `Login with Google}`,
                    windowFeatures
                  );
                }}>
              <span>
                <GoogleIcon />
              </span>
              {t('Continue with Google')}
            </button>
            <p className="sign-up-link">
              {t('Don')}&apos;{t('t have an account?')} <a onClick={() => onNext('sign-up')}>{t('Sign Up Now')}</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
